var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill-opacity":"0.35"}}),_c('path',{attrs:{"d":"M16.2,14.4a3,3,0,0,1,2.86,2.14,8.39,8.39,0,0,1-14.12,0A3,3,0,0,1,7.8,14.4h8.4ZM12,4.8A3.6,3.6,0,1,1,8.4,8.4,3.6,3.6,0,0,1,12,4.8Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }